import { FunctionComponent } from "react";

import { ApiCallButton } from "@components/buttons/ApiCallButton";
import { useRepairFederatedUser } from "@libs/api/gateways/bp-id/bp-id.hooks";

export interface RepairFederatedUserButtonProps {
  bpIdUserId: string;
}
export const RepairFederatedUserButton: FunctionComponent<RepairFederatedUserButtonProps> = ({
  bpIdUserId
}) => {
  const { mutateAsync: repair, isLoading, error } = useRepairFederatedUser();

  return (
    <ApiCallButton
      isLoading={isLoading}
      error={error}
      onClick={() => {
        repair({ bpIdUserId });
      }}
    >
      Repair
    </ApiCallButton>
  );
};
